import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { Observable } from "rxjs"
import { map } from "rxjs/operators"
import { AuthenticationService } from '../../../access/shared/authentication/authentication.service'
import { OfflineService } from '../../../shared/offline.service'
import { BasketService } from '../../basket/shared/basket.service'
import { SideBarService } from '../../shared/sidebar/side-bar.service'


@Component({
  selector: 'app-tools',
  templateUrl: './tools.component.html',
  styleUrls: ['./tools.component.scss']
})
export class ToolsComponent implements OnInit {

  badgeDescription: string = "Nombre de demandes présentes dans votre panier"

  isOnline: boolean = true

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private sideBar: SideBarService,
    private route: ActivatedRoute,
    private basketService: BasketService,
    private offlineService: OfflineService
  ) { }

  showBasket() {
    this.router.navigate([{
      outlets: {
        basket: ['basket']
      }
    }], {
      relativeTo: this.route,
      skipLocationChange: true,
    }).then(res => this.sideBar.openBasket())
  }

  ngOnInit() {
    this.offlineService.isOnline().subscribe(res => this.isOnline = res)
  }

  isBasketHidden(): Observable<boolean> {
    return this.basketService.basketCount$.pipe(map<number, boolean>(number => number == 0))
  }

  isWarning() {
    return this.basketService.basketCountWarning$.value > 0
  }

  get basketCount(): Observable<number> {
    return this.basketService.basketCount$
  }

  get basketCountWarning(): Observable<number> {
    return this.basketService.basketCount$
  }

  logout() {
    if (this.isOnline) {
      this.authenticationService.logout()
      this.router.navigate(['/login'])
    }
  }
}
